export const Empty = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center space-y-4">
      <img src="/empty.svg" />
      <p>There are no estimates to display fitting these filters</p>
    </div>
  );
};
